export default {"src":"/_next/static/media/chevron_right_secondary.a3e00614.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};